<template>
  <el-dialog
    :visible.sync="showtag"
    class="basic_atlas_catalog_go_on_look"
    width="100%"
    :append-to-body="$store.state.app.view_pattern === 'pc' ? true : false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal="$store.state.app.view_pattern === 'pc' ? true : false"
    @close="closed"
    :fullscreen="true"
  >
    <div class="go_on_frame">
      <i class="close_go_on_frame el-icon-close" @click="closed"></i>
      <div class="title">{{go_on_list.length == 1 ? $t('components_atlas_look_go_on_look_2000') : $t('components_atlas_look_go_on_look_2001')}}</div>
      <div class="jz_scroll_wrap">
        <ul class="photo_group_list">
          <li
            class="photo_group_item"
            v-for="(item,i) in go_on_list"
            :key="i"
            v-if="i < 3"
            @click="re_select(item)"
          >
            <div
              class="photo"
              v-if="item.lists.length > 0"
              :style="{
                       backgroundImage:'url(' + item.lists[0].img_path + ')'
                   }"
            >
              <div class="num">
                {{item.lists ? item.lists.length : 0}}
                <i
                  v-if="$store.state.app.view_pattern === 'pc'"
                ></i>
              </div>
            </div>
            <p
              v-if="$store.state.app.view_pattern === 'pc'"
              class="pc_name"
            >{{item.album_name ? item.album_name : $t('components_atlas_look_go_on_look_2002')}}</p>

            <p
              v-if="$store.state.app.view_pattern === 'mb'"
              class="name"
            >{{item.album_name ? item.album_name : $t('components_atlas_look_go_on_look_2002')}}</p>
          </li>
        </ul>
      </div>
    </div>
  </el-dialog>
</template>

<script type="text/javascript">
import i18n from '../../language/index'

export default {
  name: "app",
  data() {
    return {
      showtag: true
    };
  },
  props: {
    go_on_list: {
      type: Array,
      default: function() {
        return [];
      }
    },
    type: {
      type: String,
      default: "go_on"
    }
  },
  methods: {
    closed() {
      this.$store.commit("atlas_look/SET_is_Show", false);
      this.$store.commit("atlas_look/SET_now_item", null);
      this.$store.commit("atlas_look/SET_all_list", []);
    },
    re_select(item) {
      this.$emit("re_select", item);
    }
  },
  computed: {},
  created() {},
  mounted() {
    console.log(this.go_on_list);
  },
  components: {}
};
</script>

<style lang="scss" scoped>
.basic_atlas_catalog_go_on_look {
  /deep/ .el-dialog__header {
    display: none;
  }
  /deep/ .el-dialog {
    background: rgba(0, 0, 0, 0.5);
    .go_on_frame {
      position: absolute;
      margin: auto;
      background: #fff;
      left: 50%;
      top: 50%;
      -webkit-transform: translateX(-50%) translateY(-50%);
      -moz-transform: translateX(-50%) translateY(-50%);
      -ms-transform: translateX(-50%) translateY(-50%);
      -o-transform: translateX(-50%) translateY(-50%);
      transform: translateX(-50%) translateY(-50%);
      padding: 54px 86px;
      .close_go_on_frame {
        display: inline-block;
        position: absolute;
        top: 20px;
        right: 20px;
        padding: 20px;
        font-size: 26px;
        cursor: pointer;
        color: #fff;
        z-index: 999;
        color: #333;
        font-size: 15px;
        right: 0;
        top: 0;
        font-size: 28px;
      }
      .title {
        color: #333;
        font-size: 15px;
        font-weight: 400;
        margin-bottom: 40px;
        line-height: 16px;
      }
      .jz_scroll_wrap {
        .photo_group_list {
          display: block;
          margin: 0 -12px;
          white-space: nowrap;
          font-size: 0;
          .photo_group_item {
            display: inline-block;
            margin: 0 12px;
            vertical-align: top;
            width: 280px;
            cursor: pointer;
            .photo {
              width: 100%;
              height: 250px;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              background-position: center;
              position: relative;
              overflow: hidden;
              .num {
                position: absolute;
                right: 10px;
                bottom: 6px;
                font-size: 12px;
                color: #fff;
                background-color: rgba(0, 0, 0, 0.5);
                height: 24px;
                line-height: 24px;
                padding: 0 5px;
                i {
                  display: inline-block;
                  width: 14px;
                  height: 12px;
                  background: #fff;
                  margin-left: 4px;
                  margin-top: 6px;
                  vertical-align: top;
                  background: url("/static/image/backimg1.png") -23px -306px;
                }
              }
            }
            .pc_name {
              margin-top: 6px;
              margin-bottom: 9px;
              font-size: 15px;
              color: #333;
              line-height: 25px;
              max-height: 50px;
              overflow: hidden;
              -o-text-overflow: ellipsis;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              white-space: pre-wrap;
              word-break: break-all;
            }
          }
        }
      }
    }
  }
}
.mb_pattern .basic_atlas_catalog_go_on_look {
  .el-dialog {
    .go_on_frame {
      left: 0;
      top: 0;
      -webkit-transform: none;
      -moz-transform: none;
      -ms-transform: none;
      -o-transform: none;
      transform: none;
      width: 100%;
      height: 100%;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      padding: 40px 15px 20px 15px;
      background: #000;
      .title {
        color: #fff;
        margin-bottom: 25px;
      }
      .close_go_on_frame {
        padding: 10px;
        color: #fff;
      }
      .jz_scroll_wrap {
        height: -webkit-calc(100% - 41px);
        height: -moz-calc(100% - 41px);
        height: calc(100% - 41px);
        width: 100%;
        .photo_group_list {
          margin: 0 -8px;
          white-space: normal;
          height: 100%;
          overflow-x: hidden;
          overflow-y: auto;
          .photo_group_item {
            margin: 0;
            width: 50%;
            padding: 0 8px;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
            .photo {
              width: 100%;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
              background-position: center;
              position: relative;
              overflow: hidden;
              height: 0;
              padding-bottom: 90%;
            }
            .name {
              margin-top: 6px;
              font-size: 15px;
              color: #333;
              line-height: 25px;
              max-height: 50px;
              overflow: hidden;
              -o-text-overflow: ellipsis;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              white-space: pre-wrap;
              word-break: break-all;
              color: #fff;
              margin-bottom: 15px;
            }
          }
        }
        .photo_group_list::-webkit-scrollbar {
          width: 0px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/atlas_look/go_on_look.vue